<div class="content">
  <app-signature
    [title]="'signature.title' | translate"
    [loadingText]="'conciliation.signingConciliation' | translate"
    (isUserAuthenticated)="createSignature()"
  ></app-signature>
</div>
